import React from 'react';
import AppBar from '../../../commons/AppBar'
import ButtonsModules from '../../../commons/ButtonsModules';
import SiteMap from '../../../commons/SiteMap';
import SpecificComponent from '../../../commons/SpecificComponent';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { TopButtons } from '../../../commons/TopButtons';
import FromServer from '../FromServer';
import BilantChartData from '../Components/BilantChartData';
import PreviziuniChartData from '../Components/PreviziuniChartData';
import TrendDePastrareClientiTrimestru from '../TrendDePastrareClientiTrimestru';
import AnalizeClienti from '../Analize';


export default class ClasaSociala extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listSegmentare: [],
            mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
            { id: 'avc', label: 'Analiza de vanzari si client (AVC)', color: '#900DCB' },
            { id: 'segmentareaclientilorcaracteristici', label: 'Segmentarea clientilor in functie de caracteristici', color: '#900DCB' }
            ]
        }
    }

    componentDidMount() {
        this.getDateSegmentare()
    }

    getDateSegmentare = async () => {
        let a = new AnalizeClienti()

        let seg = await a.segmentareAdministratori()

        // console.warn('seg :', seg);

        this.setState({
            listSegmentare: seg.clasaSociala
        })
    }

    goTo = (id) => {
        this.props.history.push(`/${id}`)
    }


    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />

                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />

                <div style={{ textAlign: 'left' }}>
                    {this.state.mapButtons.map((b, idx) => {
                        return (
                            <SiteMap
                                key={idx}
                                b={b}
                                buttonSelected={this.goTo} />

                        )
                    })}
                </div>
                <h1 className='pm-title'>Clasa sociala</h1>

                {this.state.listSegmentare.map((e, idx) => {

                    return (
                        <div key={idx} className='container'>
                            <h4 className='pm-title'>{e.clasa}</h4>
                            <Table className='pm-indicatori-table'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            {this.dictionary.financiarContabil.nume}
                                        </TableCell>
                                        <TableCell>
                                            {this.dictionary.financiarContabil.ocupatia}
                                        </TableCell>

                                    </TableRow>
                                </TableHead>


                                <TableBody >

                                    {e.clienti.map((c, idx2) => {

                                        return (
                                            <TableRow key={'r' + idx2}>
                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                    {c.nume}
                                                </TableCell>
                                                <TableCell style={{ borderBottomColor: 'transparent', fontSize: 14, fontWeight: 500 }}>
                                                    {c.ocupatie}
                                                </TableCell>

                                            </TableRow>
                                        )


                                    })}


                                </TableBody>


                            </Table>

                        </div>
                    )

                })}

            </div>
        );
    }
}